/**
 * CONFIG LOADER - Unified Configuration System
 *
 * Este módulo carga la configuración de empresa desde company/company.config.ts
 * - En repos de empresas: contiene datos reales versionados
 * - En template: contiene placeholders para personalizar
 * - Detecta automáticamente modo template y muestra warnings
 */

import type { CompanyConfig } from '@/company/company.config';

let config: CompanyConfig;
let isUsingTemplate = false;

try {
  // Cargar configuración desde company/
  config = require('@/company/company.config').companyConfig;

  // Detectar si está usando valores de template
  isUsingTemplate = config.brand.name.includes('⚠️') ||
                    config.brand.name.includes('Configura');
} catch (error) {
  throw new Error('No se pudo cargar company/company.config.ts. Verifica que el archivo existe.');
}

// Validación adicional en desarrollo
if (process.env.NODE_ENV === 'development' && isUsingTemplate) {
  console.warn('\n========================================');
  console.warn('⚠️  USANDO CONFIGURACIÓN DE TEMPLATE');
  console.warn('========================================');
  console.warn('Para configurar tu empresa:');
  console.warn('1. Edita: company/company.config.ts');
  console.warn('2. Reemplaza valores de ejemplo con tu información real');
  console.warn('========================================\n');
}

export const companyConfig = config;
export const isTemplateMode = isUsingTemplate;

/**
 * Hook para verificar si está en modo template
 * Útil para mostrar warnings en UI
 */
export function useConfigStatus() {
  return {
    isTemplateMode,
    config: companyConfig,
  };
}
